/* NS Cart Timer Engine (singleton) — werkt ook bij AJAX DOM-replacements */
(function (w, d) {
  if (w.NSCartTimerEngine) return; // singleton

  var SEL = '.cart-timer-wrap';
  var K_END = 'ns:cartTimer:end';
  var K_QTY = 'ns:cartTimer:qty';
  var K_MIN = 'ns:cartTimer:mins';

  var state = { end: 0, qty: 0, mins: 15 };
  var bound = new Set();
  var ticking = false;

  function clamp(n, a, b) { n = parseInt(n,10); if (isNaN(n)) n = a; return Math.min(Math.max(n, a), b); }
  function load() {
    try {
      state.end  = parseInt(sessionStorage.getItem(K_END)||'0',10) || 0;
      state.qty  = parseInt(sessionStorage.getItem(K_QTY)||'0',10) || 0;
      state.mins = parseInt(sessionStorage.getItem(K_MIN)||'0',10) || 15;
    } catch(e){}
  }
  function save() {
    try {
      sessionStorage.setItem(K_END, String(state.end));
      sessionStorage.setItem(K_QTY, String(state.qty));
      sessionStorage.setItem(K_MIN, String(state.mins));
    } catch(e){}
  }
  function pad(n){ return (n<10?'0':'')+n; }
  function fmt(sec){
    if (sec < 0) sec = 0;
    var h = Math.floor(sec/3600), m = Math.floor((sec%3600)/60), s = Math.floor(sec%60);
    return h>0 ? (pad(h)+':'+pad(m)+':'+pad(s)) : (pad(m)+':'+pad(s));
  }

  function readParams() {
    // Kies een representatieve timer in DOM om actuele mins/qty te lezen
    var el = d.getElementById('cart-timer-drawer') || d.getElementById('cart-timer-page') || d.querySelector(SEL);
    if (!el) return null;
    var mins = clamp(el.dataset.minutes || state.mins || 15, 1, 180);
    var qty  = parseInt(el.dataset.cartQty || '0', 10) || 0;
    return { mins, qty };
  }

  function boot(mins, qty) {
    load();
    mins = clamp(mins || state.mins || 15, 1, 180);
    qty  = parseInt(qty || 0, 10) || 0;

    // Reset als er nog geen end is, end verlopen is, of de cart-qty gestegen is
    if (!state.end || state.end <= Date.now() || qty > state.qty) {
      state.end  = Date.now() + mins * 60 * 1000;
      state.qty  = qty;
      state.mins = mins;
      save();
    } else {
      // Bewaar laatste gewenste minuten
      state.mins = mins; save();
    }
  }

  function bind(el) {
    if (!el || bound.has(el)) return;
    bound.add(el);
  }

  function scan() {
    d.querySelectorAll(SEL).forEach(bind);
    var p = readParams();
    if (p) boot(p.mins, p.qty);
  }

  function tick() {
    load();
    // Guard: geen end bekend → probeer alsnog te booten uit DOM
    if (!state.end) {
      var p0 = readParams();
      if (p0) boot(p0.mins, p0.qty);
    } else {
      // Als DOM een hogere qty toont → reset direct
      var p1 = readParams();
      if (p1 && p1.qty > state.qty) boot(p1.mins, p1.qty);
    }

    var rem = Math.floor((state.end - Date.now())/1000);
    bound.forEach(function(el){
      if (!el.isConnected) { bound.delete(el); return; }
      var cnt = el.querySelector('.cart-timer-countdown');
      if (cnt) cnt.textContent = fmt(rem);
    });
  }

  function ensureTick() {
    if (ticking) return;
    ticking = true;
    tick();
    setInterval(tick, 1000);
  }

  // Observeer DOM voor timers die na AJAX worden ingevoegd
  var mo = new MutationObserver(function(muts){
    var found = false;
    for (var i=0; i<muts.length; i++){
      var m = muts[i];
      for (var j=0; j<m.addedNodes.length; j++){
        var n = m.addedNodes[j];
        if (!(n instanceof HTMLElement)) continue;
        if (n.matches && n.matches(SEL)) { bind(n); found = true; }
        n.querySelectorAll && n.querySelectorAll(SEL).forEach(function(el){ bind(el); found = true; });
      }
    }
    if (found) scan();
  });
  mo.observe(d.documentElement || d.body, { childList: true, subtree: true });

  // Extra events die sommige thema’s afvuren
  ['cart-drawer-component:open','cart:updated','product:added','ajaxProduct:added','cart:open'].forEach(function(evt){
    d.addEventListener(evt, function(){ scan(); });
  });

  // Init
  if (d.readyState === 'loading') {
    d.addEventListener('DOMContentLoaded', function(){ scan(); ensureTick(); });
  } else {
    scan(); ensureTick();
  }

  w.NSCartTimerEngine = { scan: scan, boot: boot }; // optioneel voor debug
})(window, document);
